import DcpLayout from "./layouts/DcpLayout";
import DlpLayout from "./layouts/DlpLayout";
import DupLayout from "./layouts/DupLayout";
import DefaultLayout from "./layouts/DefaultLayout";

class LayoutFactory {
  constructor() {
    this.layoutMap = new Map();
    this.layoutMap.set("{BB18618D-C3A6-40CF-AE7D-77AA14B2C38A}", DcpLayout);
    this.layoutMap.set("{5FB9DE71-C730-4AEC-A5A0-16860693ABE0}", DlpLayout);
    this.layoutMap.set("{534C245E-D5D9-4B2C-AFEE-0A8943B95B72}", DupLayout);
    this.layoutMap.set("default", DefaultLayout);
  }

  resolveLayout(routeData) {
    const layoutId = `{${routeData.layoutId.toUpperCase()}}`;
    const layout = this.layoutMap.get(layoutId);

    return layout || this.layoutMap.get("default");
  }
}

const layoutFactory = new LayoutFactory();

Object.freeze(layoutFactory);
export default layoutFactory;
